export default __webpack_public_path__ + "static/media/girl-survival.9cff3a23.png";